import { MMKV } from 'react-native-mmkv';

import Cipher from '../cipher';
import { EStorageKey, IStorage } from './types';

class Storage implements IStorage {
  private mmkv: MMKV | null = null;

  private getMMKV(): MMKV {
    if (!this.mmkv) {
      this.mmkv = new MMKV();
    }
    return this.mmkv;
  }

  setItem(key: EStorageKey, value: unknown): void {
    try {
      const encrypted = Cipher.encrypt(key, JSON.stringify(value));
      const mmkv = this.getMMKV();

      mmkv.delete(key);
      mmkv.set(key, JSON.stringify(encrypted));
    } catch (e) {}
  }

  getItem(key: EStorageKey) {
    try {
      const mmkv = this.getMMKV();
      const data = mmkv.getString(key);

      if (data) {
        const decrypted = Cipher.decrypt(key, JSON.parse(data));
        return decrypted ? JSON.parse(decrypted) : undefined;
      }

      return undefined;
    } catch (e) {
      return undefined;
    }
  }

  removeItem(key: EStorageKey) {
    const mmkv = this.getMMKV();
    mmkv.delete(key);
  }

  getAllKeys = () => {
    const mmkv = this.getMMKV();
    return mmkv.getAllKeys();
  };

  clearAll = () => {
    const mmkv = this.getMMKV();
    mmkv.clearAll();
  };

  // Expose raw MMKV instance for debugging tools (Reactotron)
  getMMKVInstance = (): MMKV => {
    return this.getMMKV();
  };
}

const storage = new Storage();
export default storage;
